import React, { useEffect, useState } from 'react'
import "./C2.css";
import Product from "./Product"
import Carousel from 'react-bootstrap/Carousel'
import ProductSkeleton from './components/skeleton/ProductSkeleton';
import axios from "./axios"

function C5() {
    const [snacks,setSnacks]=useState([])
    useEffect(()=>{
        axios({
            url:'products/category/snacks',
            method:'get'
        }).then(res=>setSnacks(res.data))
        .catch(err=>console.log(err))
    },[])
    return (
        <section className="contaier">
             <Carousel>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L2_DT_CXTT172_1200x300_24thmarch2021.jpg"
                    alt="First slide"
                    />
                    {/* <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                {/* <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NNP3391-1200x300-25thjul.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2805-NPL2807.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2972.jpg"
                    alt="4 slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL3027-29-31-11aug20.jpg"
                    alt="5 slide"
                    />
                </Carousel.Item> */}
            </Carousel>
            <section className="container-fluid">
            <h5 className="ml-5 mt-4">Snacks</h5> 
            <article className="row">  
                    {
                        snacks.length>0?
                        snacks.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}         
                            />
                              </article>
                        ):
                        [...Array(8)].map((s,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                                <ProductSkeleton />
                            </article>
                       )
                    }
            </article>
            </section>
        </section>
    )
}

export default C5
